import { render, staticRenderFns } from "./static-footer.vue?vue&type=template&id=cde8f186&"
import script from "./static-footer.vue?vue&type=script&lang=js&"
export * from "./static-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports